<template>
    <page>
        <div v-if="options">
            <div>
                <q-table class="shadow-25 v-list bg-hard-white"
                        id="table-other-roles"
                        :pagination.sync="pagination"
                        :infinite-scroll="infiniteScroll"
                        :loading="isLoading"
                        @request="refreshRows"
                        :data.sync="results.data"
                        :hide-header="results.data.length == 0"
                        :columns="options.columns"
                        :filter="filter"
                        :visible-columns="visibleColumns"
                        row-key="id">
                    <v-header slot="top" slot-scope="props"
                            :title="$metaInfo.title" :icon="options.icon">
                        <template slot="bottom" v-if="options.filters && Object.keys(options.filters).length > 0">

                            <q-tabs class="full-width" inverted v-model="tab">
                                <q-tab  default slot="title" name="tab-all" label="Todos" @click="applyFilter('all')"/>
                                <q-tab  slot="title" :name="`tab-${filter}`" :label="filter"
                                    v-for="(filter,key) in Object.keys(options.filters)" :key="`tab-${filter}`"
                                    @click="applyFilter(filter)"/>
                            </q-tabs>
                        </template>
                        <template slot="right">
                            <template v-if="options.canDelete">
                                <v-button dense round :color="options.isTrash ? 'primary' : 'positive'"
                                        :flat="options.isTrash"
                                        icon="list"
                                        class="on-left"
                                        @click="defaultOptions.isTrash=false">
                                    <q-tooltip anchor="top left" self="bottom middle">
                                        {{ $T('view items not in trash') }}
                                    </q-tooltip>
                                    <q-chip floating :color="options.isTrash ? 'positive' : 'primary'">
                                        {{ !options.isTrash && results.meta.total !== results.meta.total_unfiltered ?
                                        results.meta.total + '/' + results.meta.total_unfiltered :
                                        results.meta.total_unfiltered }}
                                    </q-chip>
                                </v-button>
                                <v-button dense round :color="options.isTrash ? 'negative' : 'primary'"
                                        :flat="!options.isTrash"
                                        icon="delete"
                                        class="on-left"
                                        @click="defaultOptions.isTrash=true">
                                    <q-tooltip anchor="top left" self="bottom middle">
                                        {{ $T('view items in trash') }}
                                    </q-tooltip>
                                    <q-chip floating :color="options.isTrash ? 'primary' : 'negative'">
                                        {{ options.isTrash && results.meta.total !== results.meta.total_in_trash ?
                                        results.meta.total + '/' + results.meta.total_in_trash :
                                        results.meta.total_in_trash }}
                                    </q-chip>
                                </v-button>

                                <span style="width:1px; height:40px; background: #ccc; margin: 0 18px;"></span>
                            </template>

                    <v-button flat round dense color="primary" v-if="filterOptions.length > 0"
                                icon="filter_list"
                                @click="filterDialog = true">
                        <q-tooltip anchor="top left" self="bottom middle">
                        {{ $T('filters') }}
                        </q-tooltip>
                        <q-chip floating v-if="selectedFilters.length > 0" color="negative">
                        {{ selectedFilters.length }}
                        </q-chip>
                    </v-button>

                        <v-button v-if="options.canCreate && enableCreate()"
                                flat round dense color="primary"
                                icon="add circle outline"
                                @click="createRow">
                            <q-tooltip anchor="top left" self="bottom middle">
                                {{ $T('add new') }}
                            </q-tooltip>
                        </v-button>
                        <v-button v-show="!isActiveToolbar('filter')"
                                flat round dense no-caps color="primary"
                                icon="search"
                                @click="toggleToolbar('filter')">
                            <q-tooltip v-show="!isActiveToolbar('filter')"
                                    anchor="top left" self="bottom middle">
                                {{ $T('search') }}
                            </q-tooltip>
                        </v-button>
                        <q-input v-if="isActiveToolbar('filter')"
                                hide-underline autofocus color="primary"
                                v-model="tempFilter"
                                :placeholder="$T('search')"
                                @input="updateFilter"
                                class="bg-search"
                                :before="[{icon: 'search', handler () { toggleToolbar('filter') }}]"/>
                        <v-button v-show="!isActiveToolbar('columns') && columnsOptions.length > 0"
                                flat round dense no-caps color="primary"
                                icon="view column"
                                @click="toggleToolbar('columns')">
                            <q-tooltip v-show="!isActiveToolbar('columns')"
                                    anchor="top left" self="bottom middle">
                                {{ $T('columns') }}
                            </q-tooltip>
                        </v-button>
                        <select-extended v-show="isActiveToolbar('columns')"
                                        select-all multiple toggle hide-underline
                                        color="primary"
                                        v-model="visibleColumns"
                                        :options="columnsOptions"
                                        :display-value="$T('columns')"
                                        :before="[{icon: 'view column', handler () { toggleToolbar('columns') }}]"/>
                        <v-button v-if="options.exportRoute && $router.currentRoute.path !== '/admin/audit'"
                                flat round dense no-caps color="primary"
                                icon="cloud download"
                                @click="$router.push({ name: options.exportRoute })">
                            <q-tooltip anchor="top left" self="bottom middle">
                                {{ $T('export') }}
                            </q-tooltip>
                        </v-button>
                        <v-button v-if="options.importRoute && enableImport()"
                                flat round dense no-caps color="primary"
                                icon="cloud upload"
                                @click="$router.push({ name: options.importRoute })">
                            <q-tooltip anchor="top left" self="bottom middle">
                                {{ $T('import') }}
                            </q-tooltip>
                        </v-button>
                        <v-button v-if="showStockImportButton() && enableImport()"
                                flat round dense no-caps color="primary"
                                icon="cloud upload"
                                @click="$router.push({ name: 'backoffice.lending-point.stockimport' })">
                            <q-tooltip anchor="top left" self="bottom middle">
                                {{ $T('import stock values') }}
                            </q-tooltip>
                        </v-button>

                        <v-button v-if="user.market_id == 2 && $router.currentRoute.path === '/backoffice/lending-kit'"
                                    flat round dense no-caps color="primary"
                                    icon="360"
                                    @click="$router.push({ name: 'backoffice.lending-kit.change-status' })">
                            <q-tooltip anchor="top left" self="bottom middle">
                            {{ $T('change status') }}
                            </q-tooltip>
                        </v-button>

                        </template>

                </v-header>
                <q-td slot="body-cell-description" slot-scope="props" :props="props">
                    <span v-if="highlightTableCell(props.row)" style="color: #E3813B;">{{ props.value }}</span>
                    <span v-else>{{ props.value }}</span>
                </q-td>

                <q-td slot="body-cell--actions" slot-scope="cell" class="text-right" style="width: 100px;">
                    <v-button v-show="enableImpersonate(cell.row)"
                        class="on-right"
                        color="warning"
                        icon="person"
                        @click="impersonate(cell.row.id)"
                        size="sm"
                        round
                        dense
                        />
                    <v-button v-show="!options.isTrash && options.canDetail && enableDetail(cell.row)" :disable="isLoading" color="positive"
                            class="on-right"
                            :icon="'visibility'" @click.prevent="detailRow(cell.row.id)"
                            size="sm" round dense/>

                    <v-button v-show="!options.isTrash && enableEdit(cell.row)" :disable="isLoading"
                            class="on-right"
                            :color="enableOrderEditForBO(cell.row) ? 'positive' : 'info'"
                            :icon="options.canCreate ? 'edit' : 'visibility'" @click.prevent="editRow(cell.row.id)"
                            size="sm" round dense/>

                    <v-button v-show="!options.isTrash && enableOrderEditForBO(cell.row) && isInLending(cell.row)"  :disable="isLoading" color="info"
                            class="on-right"
                            icon="edit" @click.prevent="enableOrderEdit(cell.row)"
                            size="sm" round dense/>

                    <v-button v-show="!options.isTrash && options.canDelete && enableDelete(cell.row)" :disable="isLoading" color="negative"
                            class="on-right"
                            icon="delete" size="sm" round dense>
                        <q-popover>
                            <div class="group text-center">
                                <p><strong>{{ $T('are you sure?') }}</strong></p>
                                <v-button class="no-shadow capitalize" color="negative" no-caps icon="delete"
                                        @click="deleteRow(cell.row.id)" v-close-overlay>
                                    {{ $t('delete') }}
                                </v-button>
                                <v-button class="no-shadow capitalize" color="faded" no-caps v-close-overlay>
                                    {{ $t('cancel') }}
                                </v-button>
                            </div>
                        </q-popover>
                    </v-button>

                    <v-button v-show="options.isTrash" :disable="isLoading" color="positive"
                            class="on-right"
                            icon="undo" @click.prevent="restoreRow(cell.row.id)"
                            size="sm" round dense></v-button>

                    <v-button v-show="options.isTrash && options.canDeleteForever" :disable="isLoading" color="negative"
                            class="on-right"
                            icon="delete forever"
                            size="sm" round dense>
                            <q-popover>
                                <div class="group text-center">
                                    <p><strong>{{ $T('are you sure?') }}</strong></p>
                                    <v-button class="no-shadow capitalize" color="negative" no-caps icon="delete"
                                            @click="deleteRowForever(cell.row.id)" v-close-overlay>
                                        {{ $t('delete forever') }}
                                    </v-button>
                                    <v-button class="no-shadow capitalize" color="faded" no-caps v-close-overlay>
                                        {{ $t('cancel') }}
                                    </v-button>
                                </div>
                            </q-popover>
                        </v-button>
                    </q-td>
                </q-table>
                <div 
                    class="row justify-center bg-hard-white q-pa-xl"
                    :style="$q.screen.gt.md ? 'width:88%;margin:auto;border-radius:11px;box-shadow:0px 4px 5px 0px rgb(52 48 61 / 40%);' : ''"
                    v-if="!isLoading && results.data.length == 0"
                >
                    <p class="text-subbitle1 no-margin">{{ $t('No results found') }}</p>
                </div>
            </div>
            <div :class="$q.screen.gt.sm ? 'justify-end styled-pagination q-mt-lg' : 'justify-center q-mt-md q-mb-lg'" class="row pag-row">
                <q-chip class="bg-hard-white shadow-4">
                    <q-pagination
                        ref="pagination"
                        v-model="page"
                        color="primary"
                        :max="results.meta.last_page"
                        :max-pages="4"
                        :ellipses="true"
                        direction-links
                    />
                </q-chip>
            </div>
        </div>
        <order-detail v-if="options" :item="item" :show="modalDetail" @close="modalDetail=false" @updated="refreshRows"></order-detail>
        <spinner-iqos size="60px" v-else/>
        <q-modal v-model="filterDialog" no-esc-dismiss no-backdrop-dismiss>
          <div>
              <v-header :title="$t('filters')">
                  <template slot="right">
                      <v-button flat rounded dense color="primary"
                                icon="fa icon-close"
                                @click="filterDialog = false"/>
                  </template>
              </v-header>
              <card width="100%">
                  <div class="row q-mb-md">

                      <q-select
                          v-for="(d,i) in filterOptions"
                          :key="i"
                          class="col-12"
                          multiple
                          chips
                          :float-label="d.filterName"
                          :filter="true"
                          v-model="selectedFilters"
                          :options="d.options"
                      />
                  </div>
                  <div>
                      <v-button :loading="filtering" class="q-mt-sm" no-caps :label="$T('apply')" @click="applyNewFilters" />
                      <v-button :disable="filtering" class="q-mt-sm" no-caps :label="$T('clear filters')" @click="clearFilters" />
                  </div>
              </card>
          </div>
        </q-modal>
    </page>
</template>

<script>
    import {
        debounce,
        QTable,
        QTd,
        QInput,
        QToggle,
        QPopover,
        QTooltip,
        QTabs,
        QTab
    } from 'quasar-framework'
    import axios from 'axios'
    import {userPreferences} from '../store/modules/userPreferences'
    import {mapGetters} from "vuex";
    import moment from 'moment';
    import orderDetail from '../pages/backoffice/order/_orderDetail'
    import VButton from "./form/VButton";

    const PER_PAGE = 10

    const PAGINATION_QUANTITIES = [10, 20, 50, 100]

    export default {
        name: 'list',

        metaInfo() {
            return {
                title: (this.isLoading ? this.$T('loading') + ' ' : '') + (this.options ? this.$T(this.options.plural) +
                    (this.options.isTrash ? ' ' + this.$t('in trash') : '') : '...')
            }
        },

        components: {
          VButton,
            QTable,
            QTd,
            QInput,
            QToggle,
            QPopover,
            QTooltip,
            QTabs,
            QTab,
            orderDetail
        },
        props: {
            slug: {
                type: String,
                required: true
            },
            baseRoute: {
                type: String,
                required: true
            },
            color: {
                type: String,
                default: 'white'
            },
            width: {
                type: String,
                default: '100%'
            }
        },
        methods: {
            updateFilter: debounce(function () {
                this.filter = this.tempFilter
            }, 500),

            notify(message, detail, actions = [], type = 'positive') {
                this.$q.notify({
                    type,
                    position: 'top',
                    message,
                    detail,
                    timeout: 5000,
                    actions
                })
            },

            getPaginationFromQuery() {
                if (!this.options) return
                let isTrash = getNested('trash', this.$route.query, false).toString() === 'true'
                if (this.defaultOptions.isTrash !== isTrash) {
                    this.defaultOptions.isTrash = isTrash
                }
                let page = parseInt(getNested('page', this.$route.query, 1))
                this.page = page
                let rowsPerPage = parseInt(getNested('per_page', this.$route.query, PER_PAGE))
                let pagination = {
                    page,
                    rowsPerPage,
                    sortBy: getNested('sort_by', this.$route.query, null), // String, column "name" property value
                    descending: getNested('descending', this.$route.query, true).toString() === 'true',
                    rowsNumber: this.pagination.rowsNumber || page * rowsPerPage // specifying this determines pagination is server-side
                }
                let filter = getNested('search', this.$route.query, '')

                if (objectToString(pagination) !== objectToString(this.pagination) || this.filter !== filter) {
                    this.filter = filter
                    this.pagination = pagination
                }
            },

            applyFilter(filterName) {
                this.results.data = []
                this.filterTab = filterName
                this.refreshRows('','',filterName)
            },

            async refreshRows({pagination, filter, filterTab, advancedFilter} = {pagination: null, filter: null, filterTab:null, advancedFilter: null}) {
                if (!pagination) pagination = this.pagination
                if (!filter) filter = this.filter
                if (!filterTab) filterTab = this.filterTab
                if (!advancedFilter) advancedFilter = this.advancedFilter

                let query = { // ETL from component to API
                    trash: this.options.isTrash,
                    page: pagination.page,
                    sort_by: pagination.sortBy,
                    descending: pagination.descending,
                    per_page: pagination.rowsPerPage,
                    search: filter,
                    filterTab: filterTab,
                    advancedFilter: advancedFilter
                }
                // QTable does not update the pagination and filter models directly
                this.pagination = pagination
                this.tempFilter = this.filter = filter

                if (objectToString(this.$route.query) === '{}' || pagination.page === 0)
                    this.$router.replace({query: query})
                else if (objectToString(query) !== objectToString(this.$route.query))
                    this.$router.push({query})

                let path = this.options.resourcePath

                if (this.options.isTrash) {
                    path += '/trash'
                }

              await this.request('get', path, {params: query})
                  .then((response) => {
                    // we also set (or update) rowsNumber
                    this.pagination.rowsNumber = response.meta.total

                    // then we update the rows with the fetched ones
                    this.results.meta = response.meta
                    this.results.links = response.links
                    if (response.meta.current_page == 1 || !this.infiniteScroll)
                      this.results.data = response.data
                    else
                      response.data.forEach(r => this.results.data.push(r))

                    this.results.data.filter(data => {
                      if (data.birthdate && moment(data.birthdate, 'YYYY-MM-DD', true).isValid())
                        data.birthdate = moment(data.birthdate, 'YYYY-MM-DD').format('DD-MM-YYYY')
                    })
                  })


            },

            createRow() {
                this.$router.push({name: `${this.baseRoute}.create`})
            },

            editRow(id) {
                this.$router.push({name: `${this.baseRoute}.edit`, params: {id}})
            },

            detailRow(id) {
                this.$router.push({name: `${this.baseRoute}.detail`, params: {id}})
            },

            deleteRow(id) {
                this.request('delete', this.itemPath(id))
                    .then(data => {
                        this.notify(this.$T('success'), data.success.message, [{
                            label: this.$t('undo'), handler: function () {
                                this.restoreRow(data.model.id);
                            }.bind(this)
                        }])
                        this.refreshRows()
                    })
            },

            deleteRowForever(id) {
                this.request('delete', `${this.itemPath(id)}\/force`)
                    .then(data => {
                        this.notify(this.$T('success'), data.success.message)
                        this.refreshRows()
                    })
            },

            restoreRow(id) {
                this.request('get', `${this.itemPath(id)}\/restore`)
                    .then(data => {
                        this.notify(this.$T('success'), data.success.message)
                        this.refreshRows()
                    })
            },

            acceptRow(id) {
                this.request('post', this.itemPath(id)+'/mark-as/received')
                    .then(data => {
                        this.notify(this.$T('success'), data.success.message)
                        this.refreshRows()
                    })
            },

            rejectRow(id) {
                this.request('post', this.itemPath(id)+'/mark-as/not-received')
                    .then(data => {
                        this.notify(this.$T('success'), data.success.message)
                        this.refreshRows()
                    })
            },
            itemPath(id) {
                return `${this.options.resourcePath}\/${id}`
            },

            isActiveToolbar(item) {
                return this.activeToolbar == item
            },

            toggleToolbar(item) {
                this.activeToolbar = this.activeToolbar == item ? null : item
            },

            /**
             * Submit a request.
             *
             * @param {string} requestType
             * @param {string} url
             */
            request(requestType, url, data = {}) {
                this.isLoading = true

                return new Promise((resolve, reject) => {
                    axios[requestType](url, data)
                        .then(response => {
                            this.onSuccess(response.data);

                            resolve(response.data);
                        })
                        .catch(error => {
                            this.onFail(error.response.data);

                            reject(error.response.data);
                        })
                });
            },

            /**
             * Handle a successful request.
             *
             * @param {object} data
             */
            onSuccess(data) {
                this.isLoading = false
            },

            /**
             * Handle a failed request.
             *
             * @param {object} errors
             */
            onFail(data) {
                this.isLoading = false

                if (data && data.error)
                    this.notify(this.$T('error'), data.error.message, [], 'negative')
            },

            async describe() {
                await this.$store.dispatch('crud/fetchList', this.slug)
            },

            async init() {
                await this.describe()
                this.results.data = []
                this.getPaginationFromQuery()
                await this.refreshRows()
                await this.mountFilters()
            },

            enableImpersonate(row) {
                return this.$route.name == 'admin.user.index' && row.id !== this.user.id && row['role.name'] !== 'Admin' && this.options.canImpersonate
            },
            impersonate(id) {
                window.location.href = `/impersonate/take/${id}`;
            },

            enableEdit(row) {
                const stockStatuses = window.config.stockStatuses
                let eligibleStatus = [
                    stockStatuses['AVAILABLE'],
                    stockStatuses['BROKEN'],
                    stockStatuses['PENDING_RECEPTION'],
                    stockStatuses['NOT_RECEIVED'],
                ]
                if(this.$route.name == 'admin.problem-fixer.index') {
                    return row['problemfixer_status.description'] !== 'Solucionado'
                }

                if (this.user.role.name == 'Call Center' && this.$route.name ==  'backoffice.lending-kit.index') {
                    return eligibleStatus.some((status) => {
                        return status === row['stock_status.description']
                    });
                }
                else if (this.user.role.name == 'Logista' && this.$route.name == 'backoffice.lending-point.index'){
                    return false
                }
                return true
            },

            enableDelete(row) {
                if (this.user.role.name == 'Call Center' && this.$route.name == 'backoffice.lending-kit.index') {
                    return false
                }
                else if (this.user.role.name == 'Logista' && this.$route.name == 'backoffice.lending-point.index') {
                    return false
                }
                return true
            },

            enableDetail(row) {
                if (this.user.role.name == 'Logista' && this.$route.name == 'backoffice.lending-point.index') {
                    return false
                }
                return true
            },

            enableCreate() {
                if (this.user.role.name == 'Logista' && this.$route.name == 'backoffice.lending-point.index') {
                    return false
                }
                return true
            },

            enableImport() {
                if (this.user.role.name == 'Logista' && this.$route.name == 'backoffice.lending-point.index') {
                    return false
                }
                else if (this.$route.name == 'backoffice.order.index' &&
                        ((this.user.role.name != 'Admin' && this.user.role.name != 'Backoffice') || this.user.market.abbreviation !== 'ES')) {
                    return false
                }
                return true
            },

            showStockImportButton() {
                if (this.$route.name == 'backoffice.lending-point.index') {
                    return true
                }
                return false
            },

            enableOrderEditForBO(row) {
                return this.user.market.abbreviation === 'ES' && this.user.role.name == 'Backoffice' &&
                    this.$route.name == 'backoffice.order.index'
            },

            enableOrderEdit(row) {
                this.item = row
                this.modalDetail = true
            },

            isInLending(row) {
                return this.user.market.abbreviation === 'ES' && this.user.role.name == 'Backoffice' &&
                    this.$route.name == 'backoffice.order.index' &&
                    (row['order_status.description'] === window.config.orderStatuses['IN_LENDING'] || row['order_status.description'] === window.config.orderStatuses['IN_LENDING_DELAYED'])
            },

            highlightTableCell(row) {
                return this.$route.name == 'backoffice.lending-point.index' &&
                    (this.user.role.name === 'Admin' || this.user.role.name === 'Backoffice') &&
                    row.hasOwnProperty('pos_without_stock_associated') &&
                    row.pos_without_stock_associated === this.$T('yes')
            },
            applyNewFilters () {
              this.filtering = true
              let model = ''
              if (this.$router.currentRoute.path.includes('lending-point')) {
                model = 'LendingPoint'
              } else if (this.$router.currentRoute.path.includes('lending-kit')) {
                model = 'LendingKit'
              }

              const base = btoa(model + '@' + this.selectedFilters)

              let queries = JSON.parse(JSON.stringify(this.$route.query));
              queries['advancedFilter'] = base
                this.advancedFilter = base

              this.$router.replace({query: queries})

              this.filtering = false
              this.filterDialog = false
                this.refreshRows('','','', this.advancedFilter)
            },
            async mountFilters () {
             this.filterOptions = []
              this.selectedFilters = []
              if (this.$router.currentRoute.path.includes('lending-point')) {
                this.options.columns.forEach(e=> {
                  if (e.hasFilter) {
                    let opts = []
                    this.user.filters.lendingPoints.forEach(f => {
                      const c = e.field.split('.')
                      if (c.length === 1) {
                        opts.push({ label: f[e.field].toString() , value: e.field + '|' + f[e.field] })
                      } else {
                        if (f[c[0]]) {
                          opts.push({ label: f[c[0]][c[1]], value: e.field + '|' + f[c[0]]['id'] })
                        }
                      }
                    })
                    const unique = [...new Map(opts.map(item =>
                        [item['label'], item])).values()];
                    this.filterOptions.push({
                      filterName: e.label,
                      options: unique
                    })
                  }
                })
              }
              if (this.$router.currentRoute.path.includes('lending-kit')) {
                let filterData;
                await axios.get('/api/v1/lending-point/lending-kits-filter-options/')
                  .then(res => {
                    filterData = res.data
                  })
                let t = []
                // Color
                filterData.colors.forEach(e => {
                  t.push({label: e.description, value: 'color|' + e.id})
                })
                this.filterOptions.push({
                  filterName: this.$T('product color'),
                  options: t
                })
                // Models
                t = []
                filterData.models.forEach(e => {
                  t.push({label: e.description, value: 'model|' + e.id})
                })
                this.filterOptions.push({
                  filterName: this.$T('product model'),
                  options: t
                })
                // Owner
                t = []
                filterData.owner.forEach(e => {
                  t.push({label: e.name, value: 'owner|' + e.id})
                })
                this.filterOptions.push({
                  filterName: this.$T('ownership'),
                  options: t
                })
                // Stock Status
                t = []
                filterData.stockStatus.forEach(e => {
                  t.push({label: e.description, value: 'stockStatus|' + e.id})
                })
                this.filterOptions.push({
                  filterName: this.$T('stock status'),
                  options: t
                })
                // Sub Status
                t = []
                filterData.subStatus.forEach(e => {
                  t.push({label: e.name, value: 'sub status|' + e.id})
                })
                this.filterOptions.push({
                  filterName: this.$T('sub status'),
                  options: t
                })
                // Uses
                t = []
                filterData.uses.forEach(e => {
                  t.push({label: e.uses.toString(), value: 'uses|' + e.uses})
                })
                this.filterOptions.push({
                  filterName: this.$T('uses'),
                  options: t
                })
                // Lending Points
                t = []
                filterData.lendingPoints.forEach(e => {
                  t.push({label: e.description, value: 'lendingPoint|' + e.id})
                })
                this.filterOptions.push({
                  filterName: this.$T('lending point'),
                  options: t
                })
              }
              if (this.$router.currentRoute.path.includes('order')){
                let filterData;
                await axios.get('/api/v1/lending-point/order-filter-options/')
                    .then(res => {
                      filterData = res.data
                    })
                let t = []
                // Lending Points
                filterData.lendingPoints.forEach(e => {
                  t.push({label: e.description, value: 'lendingPoint|' + e.id})
                })
                this.filterOptions.push({
                  filterName: this.$T('lending point'),
                  options: t
                })
                // Order Status
                t = []
                filterData.orderStatus.forEach(e => {
                  t.push({label: e.description, value: 'orderStatus|' + e.id})
                })
                this.filterOptions.push({
                  filterName: this.$T('order status'),
                  options: t
                })
                // noSoldReason
                t = []
                filterData.noSoldReason.forEach(e => {
                  t.push({label: e.description, value: 'noSoldReason|' + e.id})
                })
                this.filterOptions.push({
                  filterName: this.$T('no sold reason'),
                  options: t
                })
                // consumerTypes
                t = []
                filterData.consumerTypes.forEach(e => {
                  t.push({label: e.description, value: 'consumerTypes|' + e.id})
                })
                this.filterOptions.push({
                  filterName: this.$T('consumer types'),
                  options: t
                })
                // IsSold
                t = []
                filterData.isSold.forEach(e => {
                  if (e.is_sold === 'No vendido') {
                    t.push({label: e.is_sold, value: 'isSold|' + 0})
                  }
                  if (e.is_sold === 'Vendido') {
                    t.push({label: e.is_sold, value: 'isSold|' + 1})
                  }
                  if (e.is_sold === 'Vendido diferente kit') {
                    t.push({label: e.is_sold, value: 'isSold|' + 2})
                  }
                })
                this.filterOptions.push({
                  filterName: this.$T('is sold'),
                  options: t
                })
                // Seguimento
                t = []
                t.push({label: '0', value: 'follow_up|0'})
                t.push({label: '1', value: 'follow_up|1'})
                this.filterOptions.push({
                  filterName: this.$T('follow up'),
                  options: t
                })
              }
            },

            clearFilters() {
                this.selectedFilters = []
                this.applyNewFilters()
            }
        },
        mounted() {
            this.init()
        },
        updated(){
            if (!this.$refs['pagination']) return false

            let classObjArrowLeft = this.$refs['pagination'].$el.children[0].classList
            let classObjArrowRight = this.$refs['pagination'].$el.children[2].classList
            if(Object.values(classObjArrowLeft).includes('disabled')){
                this.$refs['pagination'].$el.children[0].hidden = true
            } else {
                this.$refs['pagination'].$el.children[0].hidden = false
            } 
            if(Object.values(classObjArrowRight).includes('disabled')){
                this.$refs['pagination'].$el.children[2].hidden = true
            } else {
                this.$refs['pagination'].$el.children[2].hidden = false
            }
        },
        watch: {
            slug: 'init',
            $route: 'getPaginationFromQuery',
            'page'() {
                const query = { ...this.$route.query, page: this.page }
                this.$router.replace({ query })
                this.$set(this.pagination, 'page', this.page)
                this.refreshRows()
            },
            'defaultOptions.isTrash'() {
                this.results.data = []
                this.results.meta.total = this.options.isTrash ?
                    this.results.meta.total_in_trash :
                    this.results.meta.total_unfiltered
                this.pagination.page = 1
                this.refreshRows()
            }
        },
        computed: {
            ...mapGetters({
                user: 'auth/user'
            }),
            options() {
                let options = deepCopy(this.$store.getters['crud/listDescription'](this.slug))
                if (!options) return

                // Localize labels and set default values for columns
                if (options.columns) {
                    let columns = options.columns
                    // For some reason PHP casts some arrays as objects. Convert it back to array here:
                    if (typeof columns === "object")
                        columns = Object.keys(columns).map(key => (columns[key]))
                  options.columns = columns.map(column => ({
                        name: column.field,
                        label: this.$T(column.label),
                        field: column.field,
                        align: column.align || 'left',
                        sortable: column.sortable || false,
                        required: column.required || false,
                        hasFilter: column.hasFilter || false
                    }))
                }

                let defaultOptions = deepCopy(this.defaultOptions)

                Object.assign(defaultOptions, options)

                if (options.columns && options.columns[options.columns.length - 1].name != '-actions')
                    options.columns.push({
                        label: this.$T('actions'),
                        name: '-actions',
                        align: 'right',
                        required: true
                    })

                return defaultOptions
            },
            columnsOptions() {
                return this.options.columns.filter(c => !c.required).map(c => ({value: c.field, label: c.label}))
            },
            visibleColumns: userPreferences('visibleColumns', []),
            infiniteScroll: userPreferences('infiniteScroll', false)
        },
        data() {
            return {
                tab: '',
                activeToolbar: this.$route.query.search ? 'filter' : '',
                defaultOptions: {
                    plural: 'items',
                    isTrash: false,
                    singular: 'item',
                    rowsPerPageOptions: PAGINATION_QUANTITIES
                },
                isLoading: false,
                pagination: {},
                page: 1,
                filter: '',
                filterTab: '',
                tempFilter: '',
                results: {
                    meta: {
                        total: 0,
                        total_unfiltered: 0,
                        total_in_trash: 0,
                        last_page: 1
                    },
                    data: [],
                },
                modalDetail: false,
                item: {},
                filtering: false,
                filterDialog: false,
                selectedFilters: [],
                filterOptions: [],
                advancedFilter: ''
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/List.vue